import axios from 'axios';

const axiosAgent = axios.create({
  // baseURL: 'http://kg.stage.ktvsky.com/api16931/prod',
  baseURL: process.env.VUE_APP_SOUYUORDER,
});
axiosAgent.interceptors.request.use((config) => {
  if (config.method === 'post') {
    if (config.url.includes('api16931/PROD')) { // 针对搜娱点餐页面
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    if (sessionStorage.getItem('token')) {
      config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`
    }
  }
  return config
})
axiosAgent.interceptors.response.use((res) => res.data, (error) => {
  const errMsg = error.toString()
  const code = errMsg.substr(errMsg.indexOf('code') + 5)
  if (code === '500') {
   return Promise.reject(error)
    // filter500(error, code, errMsg) // 注意这里并未返回
  }
 return Promise.reject(error)
});

export default axiosAgent;
